<div fxLayout="column" fxLayoutAlign="space-between start">
    @if (!hideLabel) {
    <div class="forge-typography--heading1">{{label}}</div>
    }

    <forge-radio-group [fxLayout]="layout" [attr.aria-label]="groupLabel">
        @for (option of options; track option) {
        <forge-radio [value]="option" [attr.name]="controlName" [formControl]="formControl" [id]="getOptionId(option)">
            @if (hasError('required')) {
            <span slot="helper-text">
                {{label}} is required
            </span>
            }
            <forge-tooltip>{{tooltip}}</forge-tooltip>
            {{ getDisplayValue(option) }}
        </forge-radio>
        }
    </forge-radio-group>
</div>